"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServerStatusMonitorResponseType_1 = require("./ServerStatusMonitorResponseType");
/**
 * A response from a Server Status Request
 */
var ServerStatusMonitorResponse = /** @class */ (function () {
    /**
     * @param {Boolean} isUp
     * @param {String|null}message
     * @param {String|null} messageSeverity
     */
    function ServerStatusMonitorResponse(isUp, message, messageSeverity) {
        if (message === void 0) { message = null; }
        if (messageSeverity === void 0) { messageSeverity = null; }
        /**
         * @type {boolean}
         * @private
         */
        this.isUp = true;
        /**
         * @type {String|null}
         * @private
         */
        this.message = null;
        /**
         * @type {ServerStatusMonitorResponseType|null}
         * @private
         */
        this.messageSeverity = null;
        this.isUp = isUp;
        this.message = message;
        this.messageSeverity = new ServerStatusMonitorResponseType_1.ServerStatusMonitorResponseType(messageSeverity);
    }
    /**
     * Check If there's a status message.
     * @returns {boolean}
     */
    ServerStatusMonitorResponse.prototype.hasMessage = function () {
        return this.message !== null;
    };
    /**
     * get the status message.
     * @returns {String|null}
     */
    ServerStatusMonitorResponse.prototype.getMessage = function () {
        return this.message;
    };
    /**
     * Get the severity code for the message.
     * @returns {ServerStatusMonitorResponseType}
     */
    ServerStatusMonitorResponse.prototype.getMessageSeverity = function () {
        return this.messageSeverity;
    };
    /**
     * Check if the service response is up
     * @returns {boolean}
     */
    ServerStatusMonitorResponse.prototype.isServerUp = function () {
        return this.isUp;
    };
    return ServerStatusMonitorResponse;
}());
exports.ServerStatusMonitorResponse = ServerStatusMonitorResponse;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VydmVyU3RhdHVzTW9uaXRvclJlc3BvbnNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1NlcnZlclN0YXR1c01vbml0b3IvU2VydmVyU3RhdHVzTW9uaXRvclJlc3BvbnNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEscUZBQW9GO0FBQ3BGOztHQUVHO0FBQ0g7SUFtQkU7Ozs7T0FJRztJQUNILHFDQUNFLElBQWEsRUFDYixPQUE2QixFQUM3QixlQUFxQztRQURyQyx3QkFBQSxFQUFBLGNBQTZCO1FBQzdCLGdDQUFBLEVBQUEsc0JBQXFDO1FBMUJ2Qzs7O1dBR0c7UUFDYyxTQUFJLEdBQVksSUFBSSxDQUFDO1FBRXRDOzs7V0FHRztRQUNjLFlBQU8sR0FBa0IsSUFBSSxDQUFDO1FBRS9DOzs7V0FHRztRQUNjLG9CQUFlLEdBQTJDLElBQUksQ0FBQztRQVk5RSxJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztRQUNqQixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUN2QixJQUFJLENBQUMsZUFBZSxHQUFHLElBQUksaUVBQStCLENBQUMsZUFBZSxDQUFDLENBQUM7SUFDOUUsQ0FBQztJQUVEOzs7T0FHRztJQUNILGdEQUFVLEdBQVY7UUFDRSxPQUFPLElBQUksQ0FBQyxPQUFPLEtBQUssSUFBSSxDQUFDO0lBQy9CLENBQUM7SUFFRDs7O09BR0c7SUFDSCxnREFBVSxHQUFWO1FBQ0UsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDO0lBQ3RCLENBQUM7SUFFRDs7O09BR0c7SUFDSCx3REFBa0IsR0FBbEI7UUFDRSxPQUFPLElBQUksQ0FBQyxlQUFlLENBQUM7SUFDOUIsQ0FBQztJQUVEOzs7T0FHRztJQUNILGdEQUFVLEdBQVY7UUFDRSxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUM7SUFDbkIsQ0FBQztJQUNILGtDQUFDO0FBQUQsQ0FBQyxBQWpFRCxJQWlFQztBQWpFWSxrRUFBMkIifQ==